document.addEventListener('DOMContentLoaded', () => {
  const getArticleBody = () => document.querySelector('.article--content');

  const getHeadings = () => {
    const articleBody = getArticleBody();
    if (!articleBody) return null;
    return articleBody.querySelectorAll('h2, h3');
  };

  const existsTableOfContents = () =>
    !!document.querySelector('.generated-toc');

  const generateAnchor = (text, id) => {
    const anchor = document.createElement('a');
    anchor.textContent = text;
    anchor.href = `#${id}`;
    anchor.classList.add('toc-link');
    anchor.style.display = 'block';
    anchor.style.lineHeight = '1.6';
    anchor.style.color = '#6f7372';
    anchor.style.textDecoration = 'none';
    return anchor;
  };

  const generateListItem = (heading, isNest = false) => {
    const listItem = document.createElement('li');
    listItem.style.listStyle = 'none';
    listItem.style.padding = isNest ? '4px 0 4px 24px' : '4px 0';
    const anchor = generateAnchor(heading.textContent.trim(), heading.id);
    listItem.appendChild(anchor);
    return listItem;
  };

  const generateList = (headings) => {
    const list = document.createElement('ul');
    list.style.padding = '0';
    list.style.margin = '12px 0 0';
    list.style.listStyle = 'none';
    Array.from(headings).forEach((heading) => {
      const isNest = heading.tagName === 'H3';
      list.appendChild(generateListItem(heading, isNest));
    });
    return list;
  };

  const generateTitle = () => {
    const title = document.createElement('span');
    title.textContent = '目次';
    title.style.fontSize = '16px';
    title.style.fontWeight = '700';
    title.style.color = '#6f7372';
    title.style.margin = '0';
    return title;
  };

  const generateTableOfContents = (headings) => {
    const toc = document.createElement('nav');
    toc.classList.add('generated-toc');
    toc.style.padding = '16px';
    toc.style.margin = '24px 0';
    toc.style.backgroundColor = '#f7f9f9';
    toc.style.borderRadius = '4px';
    toc.appendChild(generateTitle());
    toc.appendChild(generateList(headings));
    return toc;
  };

  const addIdToHeading = () => {
    const headings = getHeadings();
    if (!headings) return;
    Array.from(headings).forEach((heading, i) => {
      // encodeURIComponent ではなく「英数字＋インデックス」で安定したID生成」
      const safeId = `toc-${i}`;
      heading.setAttribute('id', safeId);
    });
  };

  const addTableOfContents = () => {
    const articleBody = getArticleBody();
    const headings = getHeadings();
    if (!articleBody || !headings || headings.length === 0) return;
    if (existsTableOfContents()) return;

    const toc = generateTableOfContents(headings);
    const firstHeading = headings[0];
    articleBody.insertBefore(toc, firstHeading);
  };

  const enableSmoothScroll = () => {
    document.querySelectorAll('.toc-link').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = link.getAttribute('href').substring(1);
        const target = document.getElementById(targetId);
        if (target) {
          const offsetTop =
            target.getBoundingClientRect().top + window.scrollY - 80; // ヘッダー分
          window.scrollTo({ top: offsetTop, behavior: 'smooth' });
        }
      });
    });
  };

  

  addIdToHeading();
  addTableOfContents();
  enableSmoothScroll();

});
